var _defs, _rect, _rect2, _circle, _rect3, _rect4, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBountyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 560,
    viewBox: "0 0 800 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0b1224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#111a33"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 560,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 744,
    height: 504,
    rx: 28,
    fill: "none",
    stroke: "#24304f",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 250,
    r: 86,
    fill: "none",
    stroke: "#2a3b61",
    strokeWidth: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 190,
    width: 180,
    height: 120,
    rx: 18,
    fill: "none",
    stroke: "#2a3b61",
    strokeWidth: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 165,
    width: 104,
    height: 28,
    rx: 10,
    fill: "#1b2747",
    stroke: "#2a3b61",
    strokeWidth: 6
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 400,
    fill: "#8ea6d9",
    fontFamily: "Arial, sans-serif",
    fontSize: 28,
    textAnchor: "middle"
  }, "Card Photo")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 438,
    fill: "#5f739e",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    textAnchor: "middle"
  }, "Placeholder preview")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBountyPlaceholder);
export default __webpack_public_path__ + "static/media/bounty-placeholder.0c8cd3e2962485896c1902d3aed0ea82.svg";
export { ForwardRef as ReactComponent };